
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 2v4H2v7.302l1 .222V22h18v-8.476l1-.222V6h-5V2H7zm8 4V4H9v2h6zm4 7.969V20H5v-6.031l4 .889 3 .642 3-.642 4-.89zm-4-1.16l5-1.111V8H4v3.698l5 1.11 3 .692 3-.691z"}})])
          )
        }
      }
    